module["exports"] = [
  "####-#####",
  "####-######"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/phone_number/formats.js
 ** module id = 1088
 ** module chunks = 0
 **/